export default __webpack_public_path__ + "static/media/Browse_modules.53e48814.jpg";